
var Modal = {
    isInit: false,
    "init": function() {
        if (this.isInit) {
            throw "Modal already initialized.";
        }
        this.$root = $('body').find('.templates');
        this.isInit = true;
    },
    "show": function(templateName, options) {
        const $modal = this.$root.find('.modal.' + templateName);
        if (!$modal.length) {
            throw "Modal not found.";
        }

        let $overlay = $('body').find('.overlay');
        if (!$overlay.length) {
            $('body').append('<div class="overlay"><div class="bgd"></div></div>');

            $overlay = $('body').find('.overlay');

            $overlay.on('click', '.close', function(e) {
                e.preventDefault();

                Modal.hide();
            });
        }

        let $overlayedModal = $overlay.find('.modal.' + templateName);
        if ($overlayedModal.length) {
            $overlayedModal.remove();
        }

        $overlay.append($modal.clone(true));

        if (typeof options != 'undefined') {
            if (typeof options.onShown != 'undefined') {
                const shownCallback = options.onShown;
                shownCallback($overlay.find('.modal'));
            }

            if (typeof options.onSubmit != 'undefined') {
                const callback = options.onSubmit;

                $modal.find('a.ok').on('click', function(e) {
                    e.preventDefault();
                    callback();
                });
            }
        }

        $overlay.show();
        
        return this;
    },
    "hide": function() {
        const $overlay = $('body').find('.overlay');
        $overlay.find('.modal').remove();
        $overlay.hide();

    }
};

export default Modal;